import React from 'react'
import Project from '../components/Project'

import MainPageLayout from '../components/MainPageLayout'

const Projects = () => {
  return (
    <MainPageLayout>
          <Project />
    </MainPageLayout>
  )
}

export default Projects